"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateReducer = void 0;
var downshift_1 = require("downshift");
exports.stateReducer = function (state, actionAndChanges) {
    var changes = actionAndChanges.changes, type = actionAndChanges.type;
    // this prevents the menu from being closed when the user selects an item with 'Enter' or mouse
    switch (type) {
        case downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter:
        case downshift_1.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case downshift_1.useSelect.stateChangeTypes.ItemClick:
            return __assign(__assign({}, changes), { isOpen: state.isOpen, highlightedIndex: state.highlightedIndex, selectedItem: __assign({}, changes.selectedItem) });
        case downshift_1.useSelect.stateChangeTypes.FunctionSelectItem:
            return __assign(__assign({}, changes), { isOpen: true });
        default:
            return changes;
    }
};
//# sourceMappingURL=stateReducer.js.map